module.exports = __webpack_public_path__ + "static/media/art5.3b242c70.png";